import { reportError } from './reportError';
import { os, browser } from './commonData';

const reportFailedRadioStreaming = async (errorType: string, stationName: string, talpaUID: string): Promise<void> => {
  const errorData = {
    errorType: errorType,
    stationName: stationName,
    OS: os,
    browser: browser,
    talpaUID: talpaUID,
  };
  reportError(errorData);
};

export { reportFailedRadioStreaming };
